module.exports = __webpack_public_path__ + "img/cooperate_zf_01@2x.840fc8b5.png";